import React from "react";
import { Spinner } from "react-bootstrap";
import "../css/Loading.css";

export default function Loading() {
  return (
    <div className="loader">
      <div className="loading">
        <h4 className="mb-5">We are taking a moment to process your payment...</h4>
        <Spinner animation="border" role="status" className="spinner mb-3" variant="warning">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </div>
  );
}
